import React, { useEffect, useState } from 'react'

import { chunkExport, loadChunk } from '../../../../../lib/chunk'
import { goodToKnow } from '../../../../../lib/good-to-know'

// Challenger B of the fold (./hero-reg.js) lives in its own script
// (lib/chunk.js), so gwmc.js carries none of it. The server picks B
// (LANDING_HERO, app/services/landing_hero.rb) and then writes gwmc:hero-src;
// with no tag this file does nothing and the control renders.
//
// Until the script has run, the server's copy of B (gwmc/_hero_reg) stays on
// screen: React would otherwise wipe it on mount and the fold would blink.
// If the script cannot load, the control's fold is shown instead.
const tag = typeof document === 'undefined' ? null : document.querySelector("meta[name='gwmc:hero-src']")
const SRC = tag && tag.getAttribute('content')
const SHELL = SRC ? document.querySelector('.hero-reg')?.outerHTML : null

export const heroReg = () => !!SRC

// The approved price promise, the shared good-to-know answer (seo/
// good_to_know.json: /faqs, How it works, the wash pages), handed to the
// chunk rather than typed again, whole: Robin's wording (26 Oct 2026), "The
// price quoted is based on the service you have selected. ..."
const priceFixed = () => goodToKnow('price').a

export const HeroRegLoader = ({ fallback }) => {
  const [Hero, setHero] = useState(() => chunkExport('HeroReg'))
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    if (!Hero) loadChunk(SRC, 'HeroReg', { copy: { priceFixed: priceFixed() } }).then(h => setHero(() => h), () => setFailed(true))
  }, [])
  if (Hero) return <Hero />
  if (failed) return fallback
  return SHELL ? <div dangerouslySetInnerHTML={{ __html: SHELL }} /> : null
}
